/// <amd-module name="Test/ManageTestPlansCommon/Constants" />
import * as Resources from "Test/ManageTestPlansCommon/Resources";

export namespace TcmPerfScenarios {
    export const Area = "TestManagement";

    export const LoadTestPlansMineNonTTI = "VSO.TFS.TRA.LoadTestPlans.Mine.NonTTI";
    export const LoadTestPlansMine = "VSO.TFS.TRA.LoadTestPlans.Mine";
    export const LoadTestPlansAllNonTTI = "VSO.TFS.TRA.LoadTestPlans.All.NonTTI";
    export const LoadTestPlansAll = "VSO.TFS.TRA.LoadTestPlans.All";
    export const FetchTestPlansMetadata = "VSO.TFS.TRA.LoadTestPlans.FetchTestPlansMetadata";
    export const FetchTestPlansAllPageData = "VSO.TFS.TRA.LoadTestPlans.FetchTestPlansAllPageData";
    export const FetchTestPlansMinePageData = "VSO.TFS.TRA.LoadTestPlans.FetchTestPlansMinePageData";
    export const FetchTestPlansMySkinnyPageData = "VSO.TFS.TRA.LoadTestPlans.FetchTestPlansMySkinnyPageData";
    export const LoadTestPlansHubRefresh = "VSO.TFS.TRA.LoadTestPlansHubRefresh";
    export const LoadTestCaseResults = "VSO.TFS.TRA.LoadTestCaseResults";
}

export namespace ManageTestPlansCommonConstants{
    export const SortPlansAndSuitesAlphabeticallyFF = "WebAccess.TestManagement.SortPlansAndSuitesAlphabetically";
}
export namespace TelemetryConstants {
    export const areaTestManagement: string = "TestManagement";
    export const testHubPage: string = "TestHub";
    export const mineAllPage: string = "MineAllPage";
    export const mineAllPage_Error: string = "MineAllPageError";

    // new test plan telemetry points
    export const featureNewTestPlanHub: string = "NewTestPlanHub";
    export const navigateToAllPlansPage: string = "NavigateToAllPlansPage";
    export const featureNewTestPlan_Payload: string = "NewTestPlan_Payload";
    export const featureNewTestPlan_FilterClick: string = "NewTestPlan_FilterClick";
    export const navigateToMyPlansPage: string = "NavigateToMyPlansPage";
    export const testPlanDirectoryFilterClick: string = "TestPlanDirectoryFilterClick";
}

/**
 * Pivot types for directory page
 */
export enum DirectoryPivotType {
    mine = "mine",
    all = "all",
    new = "new"
}

export module TestPlanRouteParameters {
    export const Name = "name";
    export const Pivot = "pivot";
    export const DefineTabRouteValue = "define";
}

export namespace TestPlanPivotColumnKeys {
    export const testPlanId = "testPlanId";
    export const Title = "Title";
    export const State = "State";
    export const Area = "Area";
    export const Iteration = "Iteration";
    export const AssignedTo = "AssignedTo";
}

export enum FavoriteState {
    Favorited = 1,
    Unfavourited = 2,
    Favoriting = 3,
    Unfavoriting = 4
}

/**
 * Enum to represent the type of a filter on the filter bar.
 */
export enum TestPlanFilterFieldType {
    /** Text input */
    Text,

    /** Filter values will be rendered using a list with checkboxes */
    CheckboxList
}

/**
 * Defines a single field on the filter bar.
 */
export interface ITestPlanFilterField {
    displayType: TestPlanFilterFieldType;
    fieldName: string;
    placeHholder: string;
}

/**
 *  Filter item names used in directory pages.
 */
export namespace Filters {
    export const TeamFilterItemKey: string = "TestPlanDirectoryFilter-Team";
    export const KeywordFilterItemKey: string = "TestPlanDirectoryFilter-Keyword";
    export const StateFilterItemKey: string = "TestPlanDirectoryFilter-State";
    export const IterationFilterItemKey: string = "TestPlanDirectoryFilter-Iteration";
    export const AreaPathFilterItemKey: string = "TestPlanDirectoryFilter-AreaPath";
    export const AssignedToFilterItemKey: string = "TestPlanDirectoryFilter-AssignedTo";

    // Filters to be shown on mine page
    export const MineTabFilterItems: ITestPlanFilterField[] = [
        {
            displayType: TestPlanFilterFieldType.Text,
            fieldName: KeywordFilterItemKey,
            placeHholder: Resources.TestPlan_KeywordFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: StateFilterItemKey,
            placeHholder: Resources.TestPlan_StateFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: IterationFilterItemKey,
            placeHholder: Resources.TestPlan_IterationFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: TeamFilterItemKey,
            placeHholder: Resources.TestPlan_TeamFilterText
        }
    ];

    // filters to be shown on all page
    export const AllTabFilterItems: ITestPlanFilterField[] = [
        {
            displayType: TestPlanFilterFieldType.Text,
            fieldName: KeywordFilterItemKey,
            placeHholder: Resources.TestPlan_KeywordFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: StateFilterItemKey,
            placeHholder: Resources.TestPlan_StateFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: AreaPathFilterItemKey,
            placeHholder: Resources.TestPlan_AreaPathFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: IterationFilterItemKey,
            placeHholder: Resources.TestPlan_IterationFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: AssignedToFilterItemKey,
            placeHholder: Resources.TestPlan_AssignedToFilterText
        }
    ];

    // Filters of mine and all tab combined (used to populate dropdown values for the filters)
    export const AllFilterItems: ITestPlanFilterField[] = [
        {
            displayType: TestPlanFilterFieldType.Text,
            fieldName: KeywordFilterItemKey,
            placeHholder: Resources.TestPlan_KeywordFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: StateFilterItemKey,
            placeHholder: Resources.TestPlan_StateFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: IterationFilterItemKey,
            placeHholder: Resources.TestPlan_IterationFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: AreaPathFilterItemKey,
            placeHholder: Resources.TestPlan_AreaPathFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: TeamFilterItemKey,
            placeHholder: Resources.TestPlan_TeamFilterText
        },
        {
            displayType: TestPlanFilterFieldType.CheckboxList,
            fieldName: AssignedToFilterItemKey,
            placeHholder: Resources.TestPlan_AssignedToFilterText
        }
    ];
}

/**
 *  Keys for my testplan directory page groups
 */
export namespace MineTestPlanPivotGroupKeys {
    export const FavoritesGroupKey = "mineTestPlan.group.favorites";
    export const TeamsGroupKey = "mineTestPlan.group.teams";
}

export namespace WorkItemField {
    export const workItemType: string = "System.WorkItemType";
    export const testPlanId: string = "System.Id";
    export const title: string = "System.Title";
    export const iterationPath: string = "System.IterationPath";
    export const assignedTo: string = "System.AssignedTo";
    export const workItemState: string = "System.State";
    export const areaPath: string = "System.AreaPath";
    export const systemInfo: string = "Microsoft.VSTS.TCM.SystemInfo";
    export const url: string = "url";
    export const priority: string = "Microsoft.VSTS.Common.Priority";
}
